import { render, staticRenderFns } from "./accumulatePoints.vue?vue&type=template&id=5878646d&scoped=true"
import script from "./accumulatePoints.vue?vue&type=script&lang=js"
export * from "./accumulatePoints.vue?vue&type=script&lang=js"
import style0 from "./accumulatePoints.vue?vue&type=style&index=0&id=5878646d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5878646d",
  null
  
)

export default component.exports